import React, { Component } from "react";
import { MenuItem, Grid, Button, InputLabel } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Field, reduxForm } from "redux-form";
import validate from "./validateArticle";
import {
    renderTextField,
    renderSelectField,
    renderTextEditor,
    renderMultiDropzoneImageField
} from "../../../helpers";
import { withTranslation } from "react-i18next"; // Import withTranslation

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit
    },
    dateField: {
        width: 200
    }
});

class ArticleForm extends Component {
    render() {
        const {
            classes,
            handleSubmit,
            onDrop,
            userId,
            pristine,
            submitting,
            article,
            t // Use t for translations
        } = this.props;
        const path = `/uploads/articlesImages/`;

        return (
            <div>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={16}>
                        <Grid item xs={12} md={6}>
                            <Field
                                name="articleTypeId"
                                component={renderSelectField}
                                label={t('type')} // Translated label
                                margin="dense">
                                <MenuItem value={1}>{t('newsone')}</MenuItem> {}
                                <MenuItem value={2}>{t('event')}</MenuItem> {}
                                <MenuItem value={3}>{t('page')}</MenuItem> {}
                            </Field>
                            <Field
                                name="eventDate"
                                component={renderTextField}
                                type="date"
                                className={classes.dateField}
                                label={t('eventDate')} // Translated label
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                            <Field
                                name="eventDateEnd"
                                component={renderTextField}
                                type="date"
                                className={classes.dateField}
                                label={t('endDate')} // Translated label
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                            <Field
                                name="eventLocation"
                                component={renderTextField}
                                style={{ marginLeft: 7 }}
                                margin="dense"
                                className={classes.eventLocation}
                                label={t('eventLocation')} // Translated label
                            />
                            <Field
                                name="eventLocationEn"
                                component={renderTextField}
                                style={{ marginLeft: 7 }}
                                margin="dense"
                                className={classes.eventLocation}
                                label={t('eventLocationEn')} // Translated label
                            />
                            <Field
                                name="title"
                                component={renderTextField}
                                style={{ marginLeft: 7 }}
                                margin="dense"
                                fullWidth
                                label={t('title')} // Translated label
                            />
                            <Field
                                name="titleEn"
                                component={renderTextField}
                                style={{ marginLeft: 7 }}
                                margin="dense"
                                fullWidth
                                label={t('titleEn')} // New translation key
                            />
                            <Field
                                name="coverImg"
                                component={renderTextField}
                                style={{ marginLeft: 7 }}
                                margin="dense"
                                fullWidth
                                label={t('coverImage')} // Translated label
                            />
                            <br />

                            <label htmlFor="content">{t('content')}</label>
                            <Field
                                name="content"
                                component={renderTextEditor}
                                style={{ marginLeft: 7 }}
                                margin="dense"
                                fullWidth
                                label={t('content')} // Translated label
                            />
                            <br />

                            <label htmlFor="contentEn">{t('contentEn')}</label>
                            <Field
                                name="contentEn"
                                component={renderTextEditor}
                                style={{ marginLeft: 7 }}
                                margin="dense"
                                fullWidth
                                label={t('contentEn')} // New translation key
                            />
                            <br />
                            <Grid align="right">
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.menuButton}>
                                    {t('publish')} {}
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item md={5}>
                            <InputLabel>{t('articleImages')}</InputLabel> {}
                            <Field
                                name="imagesFiles"
                                component={renderMultiDropzoneImageField}
                                userId={userId}
                                folderName="articlesImages"
                                onChange={onDrop}
                            />
                            {article.imagesNames && Array.isArray(article.imagesNames) && (
                                <div>
                                    {article.imagesNames.map((file, i) => (
                                        <div key={i}>
                                            <img
                                                alt={t('articleImageAlt')} /* Translated alt text */
                                                style={{ width: 300 }}
                                                id={"article-img-" + i}
                                                src={`${path}/${file ? file : "ERROR"}`}
                                            />
                                            <br />
                                            <input
                                                type="text"
                                                disabled
                                                value={`${path}/${file ? file : "ERROR"}`}
                                                style={{ padding: 8, width: 300 }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Grid>
                    </Grid>
                </form>
            </div>
        );
    }
}

// Wrap the component with withTranslation HOC
export default withTranslation()(
    withStyles(styles)(
        reduxForm({
            form: "ArticleForm", // a unique identifier for this form
            validate
        })(ArticleForm)
    )
);

//import React, { Component } from "react";
//import { MenuItem, Grid, Button, InputLabel } from "@material-ui/core";
//import { withStyles } from "@material-ui/core/styles";
//import { Field, reduxForm } from "redux-form";
//import validate from "./validateArticle";
//import {
//	renderTextField,
//	renderSelectField,
//	renderTextEditor,
//	renderMultiDropzoneImageField
//} from "../../../helpers";

//const styles = theme => ({
//	margin: {
//		margin: theme.spacing.unit
//	},
//	dateField: {
//		width: 200
//	}
//});

//class ArticleForm extends Component {
//	render() {
//		const {
//			classes,
//			handleSubmit,
//			onDrop,
//			userId,
//			pristine,
//            submitting,
//            article
//		} = this.props;
//        const path = `/uploads/articlesImages/`;

//		return (
//			<div>
//				<form onSubmit={handleSubmit}>
//					<Grid container spacing={16}>
//						<Grid item xs={12} md={6}>
//							<Field
//								name="articleTypeId"
//								component={renderSelectField}
//								label="Тип"
//								margin="dense">
//								<MenuItem value={1}>Новина</MenuItem>
//								<MenuItem value={2}>Събитие</MenuItem>
//								<MenuItem value={3}>Страница</MenuItem>
//							</Field>
//							<Field
//								name="eventDate"
//								component={renderTextField}
//								type="date"
//								className={classes.dateField}
//								label="Дата на събитието"
//								InputLabelProps={{
//									shrink: true
//								}}
//							/>
//                            <Field
//                                name="eventDateEnd"
//                                component={renderTextField}
//                                type="date"
//                                className={classes.dateField}
//                                label="Крайна дата"
//                                InputLabelProps={{
//                                    shrink: true
//                                }}
//                            />
//							<Field
//								name="eventLocation"
//								component={renderTextField}
//								style={{ marginLeft: 7 }}
//								margin="dense"
//								className={classes.eventLocation}
//								label="Място на събитието"
//							/>
//							<Field
//								name="title"
//								component={renderTextField}
//								style={{ marginLeft: 7 }}
//								margin="dense"
//								fullWidth
//								label="Заглавие"
//							/>
//							<Field
//								name="coverImg"
//								component={renderTextField}
//								style={{ marginLeft: 7 }}
//								margin="dense"
//								fullWidth
//								label="Снимка към публикацията"
//							/>
//							<Field
//								name="content"
//								component={renderTextEditor}
//								style={{ marginLeft: 7 }}
//								margin="dense"
//								fullWidth
//								label="Съдържание"
//							/>
//							<br />
//							<Grid align="right">
//								<Button
//									variant="contained"
//									type="submit"
//									color="primary"
//									className={classes.menuButton}>
//									Публикувай
//								</Button>
//							</Grid>
//						</Grid>
//						<Grid item md={5}>
//							<InputLabel>Снимки към статията</InputLabel>
//							<Field
//								name="imagesFiles"
//								component={renderMultiDropzoneImageField}
//								userId={userId}
//								folderName="articlesImages"
//								onChange={onDrop}
//							/>
//							{article.imagesNames && Array.isArray(article.imagesNames) && (
//								<div>
//									{article.imagesNames.map((file, i) => (
//										<div key={i}>
//											<img
//												alt="Снимка към статията"
//												style={{ width: 300 }}
//												id={"article-img-" + i}
//												src={`${path}/${file ? file : "ERROR"}`}
//											/>
//											<br />
//											<input
//												type="text"
//												disabled
//												value={`${path}/${file ? file : "ERROR"}`}
//												style={{ padding: 8, width: 300 }}
//											/>
//										</div>
//									))}
//								</div>
//							)}
//						</Grid>
//					</Grid>
//				</form>
//			</div>
//		);
//	}
//}

//export default withStyles(styles)(
//	reduxForm({
//		form: "ArticleForm", // a unique identifier for this form
//		validate
//	})(ArticleForm)
//);
